import type { Order } from '$lib/types/order';
import { cancelFullOrderRequest } from '../connectors/advancedOrders';
import { cancelLimitOrder, cancelStandardOrder, executeDelayedOrder } from '../connectors/orders';
import type { IBuilderReturnData } from '../types';

export const buildExpiredOrderCallData = async (
	expiredOrders: Array<Order>
): Promise<IBuilderReturnData> => {
	let _targetArray: Array<string> = [];
	let _callDataArray: Array<string> = [];
	for (let i = 0; i < expiredOrders.length; i++) {
		let order = expiredOrders[i];
		if (order.status === 'Expired') {
			if (order.orderType === 'Limit') {
				const { _target, _callData } = await cancelLimitOrder(order.requestId);
				_targetArray.push(_target);
				_callDataArray.push(_callData);
			} else if (order.orderType === 'Advanced') {
				const { _target, _callData } = cancelFullOrderRequest(order.orderId.toString());
				_targetArray.push(_target);
				_callDataArray.push(_callData);
			} else {
				const { _target, _callData } = await cancelStandardOrder(order.marketIdentifier);
				_targetArray.push(_target);
				_callDataArray.push(_callData);
			}
		}
	}
	return {
		_targetArray,
		_callDataArray
	};
};

export async function buildManuallyExecuteDelayedOrder(
	market: `0x${string}`,
	callData: Array<string>
): Promise<IBuilderReturnData> {
	let _targetArray: Array<string> = [];
	let _callDataArray: Array<string> = [];

	const manuallyExecuteDelayedOrderCallData = await executeDelayedOrder(market, callData);

	_targetArray.push(manuallyExecuteDelayedOrderCallData._target);
	_callDataArray.push(manuallyExecuteDelayedOrderCallData._callData);

	return {
		_targetArray,
		_callDataArray
	};
}
